import { BitcoinFaceLogoProps } from "../../store/faces";

const BitcoinFace675 = (props: BitcoinFaceLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 147 147"
    width={props.width}
    height={props.height}
  >
    <g clipPath="url(#prefix__a)">
      <path fill="#FDC4FF" d="M150.675 0H0v150.675h150.675V0Z" />
      <path fill="#BA3D11" d="M124.803 66.54H23.698v81.168h101.105V66.541Z" />
      <path fill="#542F5F" d="M101.677 66.319H45.483v81.389h56.194v-81.39Z" />
      <path fill="#172027" d="M102.165 66.319H73.553v81.389h28.612v-81.39Z" />
      <path
        fill="#DF2D2C"
        d="M73.637 124.788c28.032 0 50.756-22.724 50.756-50.756s-22.724-50.756-50.756-50.756S22.88 46 22.88 74.032s22.725 50.756 50.757 50.756Z"
      />
      <path
        fill="#C12E58"
        d="M74.04 23.276c28.031 0 50.756 22.725 50.756 50.756 0 28.032-22.725 50.758-50.756 50.758"
      />
      <path
        fill="#F26227"
        d="M20.827 78.892a9.002 9.002 0 1 0 0-18.005 9.002 9.002 0 0 0 0 18.005Z"
      />
      <path
        fill="#D74B27"
        d="M20.827 77.769a7.88 7.88 0 1 0 0-15.759 7.88 7.88 0 0 0 0 15.759Z"
      />
      <path
        fill="#F79421"
        d="M20.48 62.637h.709c.048.007.097.01.147.01.205.017.41.038.614.07.484.074.959.198 1.417.37a7.284 7.284 0 0 1 4.365 4.556 6.973 6.973 0 0 1 .335 1.851.217.217 0 0 0 .01.11v.588a.2.2 0 0 0-.01.11 7.037 7.037 0 0 1-.806 2.937 7.247 7.247 0 0 1-7.037 3.893 7.033 7.033 0 0 1-1.386-.25 7.213 7.213 0 0 1-4.034-2.91 7.215 7.215 0 0 1-1.227-3.47 1.838 1.838 0 0 0-.022-.254V69.551a.083.083 0 0 0 .01-.052c.016-.315.053-.629.112-.938a7.25 7.25 0 0 1 6.637-5.906 1.34 1.34 0 0 0 .166-.018Zm-5.702 7.257a6.051 6.051 0 1 0 6.049-6.058 6.045 6.045 0 0 0-6.049 6.058Z"
      />
      <path
        fill="#F79421"
        d="M22.651 69.68c.257.042.507.12.743.229a1.6 1.6 0 0 1 .716.636c.11.194.18.408.205.63.038.28.026.565-.036.842a1.48 1.48 0 0 1-.924 1.088c-.252.1-.515.169-.783.207a5.6 5.6 0 0 1-.546.059c-.063 0-.064 0-.064.07v1.078c0 .067 0 .067-.07.067h-.786c-.076 0-.072 0-.072-.07v-1.043c0-.086.008-.077-.08-.077h-.784c-.063 0-.063 0-.063.064v1.05c0 .08.007.076-.074.076h-.782c-.073 0-.075 0-.075-.076v-1.078c0-.025-.009-.04-.035-.036-.027.003-.038 0-.056 0h-1.717c-.03 0-.045 0-.045-.043v-.772c0-.037.014-.047.05-.045h.479c.099-.002.197-.015.294-.038a.26.26 0 0 0 .21-.214 1.61 1.61 0 0 0 .038-.386V67.86a1.69 1.69 0 0 0-.035-.365.277.277 0 0 0-.232-.228 1.879 1.879 0 0 0-.374-.034h-.361c-.064 0-.064 0-.064-.066v-.716c0-.082 0-.076.074-.076h1.702c.077 0 .077 0 .077-.075v-1.07c0-.02.013-.037.038-.035h.814c.082 0 .075-.01.075.073v1.022c0 .095 0 .085.085.085h.78c.063 0 .063 0 .063-.068V65.23c0-.016.01-.038.037-.037h.814c.08 0 .076-.012.076.08v1.062c0 .053 0 .052.055.056.28.019.556.064.827.134.152.04.3.094.441.163a1.252 1.252 0 0 1 .684.823c.09.32.095.659.016.982a1.402 1.402 0 0 1-.566.816c-.221.153-.466.27-.725.344-.019.006-.035.001-.044.026Zm-2.544 1.681v1.126c0 .06 0 .06.06.06h.407a5.9 5.9 0 0 0 .867-.04c.17-.022.338-.065.497-.127a.857.857 0 0 0 .515-.565c.08-.262.092-.541.035-.81a.85.85 0 0 0-.38-.574 1.222 1.222 0 0 0-.365-.147 3.19 3.19 0 0 0-.625-.089c-.323-.019-.648 0-.973-.01-.034 0-.046.013-.043.044.003.031 0 .033 0 .049l.005 1.083Zm0-3.087v1c0 .034.007.051.045.05.35.01.7 0 1.048-.03.171-.019.338-.06.499-.122a.755.755 0 0 0 .467-.54c.054-.213.061-.436.022-.653a.735.735 0 0 0-.517-.62 2.454 2.454 0 0 0-.682-.121c-.274-.013-.547 0-.82 0h-.036a.03.03 0 0 0-.024.009.03.03 0 0 0-.008.025v.055c.003.319.004.635.004.947h.002Z"
      />
      <path
        fill="#F26227"
        d="M131.959 79.33a9.002 9.002 0 0 0 9.002-9.002 9.002 9.002 0 1 0-18.004 0 9.002 9.002 0 0 0 9.002 9.002Z"
      />
      <path
        fill="#D74B27"
        d="M131.959 78.207a7.88 7.88 0 1 0 0-15.759 7.88 7.88 0 0 0 0 15.759Z"
      />
      <path
        fill="#F79421"
        d="M131.612 63.073h.709a.762.762 0 0 0 .147.01c.205.018.41.04.614.071.483.075.957.199 1.414.37a7.281 7.281 0 0 1 4.365 4.558 7.025 7.025 0 0 1 .335 1.85.223.223 0 0 0 .01.112v.588a.203.203 0 0 0-.01.112 7.028 7.028 0 0 1-.806 2.936 7.262 7.262 0 0 1-8.423 3.643 7.223 7.223 0 0 1-4.034-2.91 7.234 7.234 0 0 1-1.227-3.47 1.826 1.826 0 0 0-.022-.255V69.999a.086.086 0 0 0 .01-.055c.016-.314.053-.627.112-.936a7.049 7.049 0 0 1 .601-1.828 7.278 7.278 0 0 1 4.769-3.88c.416-.104.84-.17 1.267-.2.057-.005.114-.013.169-.027Zm-5.702 7.258a6.05 6.05 0 1 0 6.049-6.053 6.045 6.045 0 0 0-6.049 6.053Z"
      />
      <path
        fill="#F79421"
        d="M133.783 70.116c.254.043.502.12.735.23.299.134.549.356.716.637.111.194.181.408.206.63.038.28.025.566-.037.842a1.464 1.464 0 0 1-.923 1.086c-.252.1-.515.17-.784.207-.18.028-.361.049-.545.06-.063 0-.065 0-.065.07v1.077c0 .068 0 .07-.069.07h-.786c-.077 0-.072 0-.072-.073V73.91c0-.087 0-.078-.08-.078h-.784c-.064 0-.064 0-.064.066v1.05c0 .08.008.076-.073.076h-.775c-.073 0-.075 0-.075-.078V73.87c0-.025-.009-.038-.035-.037H128.5c-.031 0-.046-.007-.046-.04v-.773c0-.038.015-.047.05-.047h.48a1.38 1.38 0 0 0 .294-.038.264.264 0 0 0 .139-.073.266.266 0 0 0 .071-.14c.028-.127.041-.256.038-.385v-4.038a1.667 1.667 0 0 0-.035-.366.277.277 0 0 0-.232-.228 1.887 1.887 0 0 0-.374-.034h-.361c-.064 0-.064 0-.064-.066v-.716c0-.08 0-.077.074-.077h1.702c.077 0 .077 0 .077-.073v-1.07c0-.018.013-.038.038-.037h.814c.082 0 .075-.007.075.074v1.021c0 .096-.007.085.085.085h.779c.064 0 .064 0 .064-.066v-1.077c0-.016.01-.038.036-.037h.815c.081 0 .076-.01.076.08v1.065c0 .053 0 .053.055.056.279.02.556.065.827.135.152.04.3.094.441.162a1.259 1.259 0 0 1 .684.823c.09.321.095.66.016.984a1.397 1.397 0 0 1-.566.814c-.221.153-.466.27-.725.344-.019.002-.035-.001-.044.022Zm-2.544 1.682v1.126c0 .06 0 .06.06.06h.407c.29.007.58-.007.867-.043a2.08 2.08 0 0 0 .497-.125.855.855 0 0 0 .515-.566c.08-.262.092-.54.035-.81a.846.846 0 0 0-.379-.574 1.22 1.22 0 0 0-.366-.147 3.407 3.407 0 0 0-.625-.088c-.323-.02-.648 0-.973-.01-.034 0-.046.013-.043.045.003.032 0 .032 0 .048.003.362.003.722.005 1.084Zm0-3.087v1.001c0 .032.007.05.045.048.35.01.7 0 1.048-.03.171-.018.338-.06.499-.121a.748.748 0 0 0 .467-.538c.054-.215.061-.438.022-.656a.733.733 0 0 0-.517-.62 2.46 2.46 0 0 0-.682-.12c-.274-.014-.547 0-.821-.007h-.035c-.022 0-.034.01-.032.034v.056l.004.953h.002Z"
      />
      <path
        fill="#DF2D2C"
        d="M19.817 49.561h31.192v26.46H19.817A10.584 10.584 0 0 1 9.233 65.437v-5.292a10.584 10.584 0 0 1 10.584-10.584Z"
      />
      <path
        fill="#C12E58"
        d="M129.334 76.021h-21.73v-26.46h21.73a10.584 10.584 0 0 1 10.584 10.584v5.292a10.584 10.584 0 0 1-10.584 10.584Z"
      />
      <path
        fill="#A02960"
        d="M25.109 59.484a4.63 4.63 0 0 0-9.261 0v6.615a4.63 4.63 0 0 0 9.261 0v-6.615Z"
      />
      <path
        fill="#4A2955"
        d="M134.036 59.484a4.63 4.63 0 1 0-9.261 0v6.615a4.63 4.63 0 1 0 9.261 0v-6.615Z"
        opacity={0.45}
      />
      <path
        fill="#542F5F"
        d="M58.239 83.41a16.226 16.226 0 0 0 32.395 0H58.24Z"
      />
      <path
        fill="#001A1B"
        d="M62.263 86.077a12.243 12.243 0 0 0 23.977 0H62.263Z"
      />
      <path
        fill="#FFF8DA"
        d="M51.215 72.18c6.137 0 11.111-4.975 11.111-11.112 0-6.137-4.974-11.112-11.111-11.112-6.137 0-11.112 4.975-11.112 11.112 0 6.137 4.975 11.112 11.112 11.112Z"
      />
      <path
        fill="#ABA2CA"
        d="M98.128 72.18c6.137 0 11.112-4.975 11.112-11.112 0-6.137-4.975-11.111-11.112-11.111-6.136 0-11.111 4.974-11.111 11.111 0 6.137 4.975 11.112 11.111 11.112Z"
      />
      <path
        fill="#2C1F41"
        d="M51.215 67.24a6.172 6.172 0 1 0 0-12.344 6.172 6.172 0 0 0 0 12.345Z"
      />
      <path
        fill="#172027"
        d="M98.128 67.24a6.173 6.173 0 1 0 0-12.345 6.173 6.173 0 0 0 0 12.346Z"
      />
      <path
        fill="#F9C1C0"
        d="m68.286 61.72-3.73 15.546h9.945v-17.85M64.557 77.266H74.5v2.303l-9.944-2.303Z"
      />
      <path
        fill="#883A62"
        d="M64.557 77.266c1.617 1.876 4.427 3.48 8.057 4.6l1.887.588V79.57l-9.944-2.304Z"
      />
      <path
        fill="#F489AE"
        d="M80.702 61.691 84.43 77.24h-9.946V59.388M84.431 77.24h-9.946v2.303l9.946-2.303Z"
      />
      <path
        fill="#4D2F47"
        d="M84.428 77.24c-1.617 1.874-4.429 3.478-8.057 4.598l-1.889.588v-2.883l9.946-2.303Z"
      />
      <path
        fill="#DF4624"
        d="m97.632 35.392 10.961-13.807v4.313c0 3.056-2.425 5.91-6.468 7.605l-4.493 1.889Z"
      />
      <path
        fill="#F96020"
        d="M53.186 35.227 42.23 21.422v4.313c0 3.055 2.424 5.908 6.468 7.603l4.488 1.89Z"
      />
      <path
        fill="#BA3272"
        d="M71.658 28.25V9.85l-1.294.814c-7.357 4.634-7.357 12.145 0 16.779l1.294.808Z"
      />
      <path
        fill="#8E97C4"
        d="M71.658 28.25 57.043 16.746v6.903l14.615 11.504"
      />
      <path
        fill="#BA3272"
        d="M57.043 23.65V2.94l-4.386 5.524c-4.323 5.447-6.574 11.452-6.574 17.54v6.849h23.426"
      />
      <path
        fill="#532D5A"
        d="M79.16 28.415V10.006l1.29.816c7.35 4.632 7.35 12.145 0 16.777l-1.29.816Z"
      />
      <path fill="#4F4F8E" d="m79.16 28.415 14.614-11.506v6.903L79.16 35.317" />
      <path
        fill="#532D5A"
        d="M93.776 23.814V3.104L98.16 8.63c4.324 5.439 6.575 11.451 6.575 17.54v6.847H81.534"
      />
      <path
        fill="#F96020"
        d="m71.658 28.25-10.96-13.806v4.315c0 3.054 2.424 5.908 6.46 7.602l4.5 1.89Z"
      />
      <path
        fill="#DF4624"
        d="M79.16 28.415 90.12 14.61v4.313c0 3.056-2.424 5.91-6.468 7.603l-4.494 1.89Z"
      />
      <path
        fill="#F96020"
        d="M75.507 35.997a8.03 8.03 0 1 0 0-16.061 8.03 8.03 0 0 0 0 16.061Z"
      />
      <path
        fill="#D74816"
        d="M75.505 34.996a7.03 7.03 0 1 0 0-14.059 7.03 7.03 0 0 0 0 14.06Z"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <rect width={147} height={147} fill="#fff" rx={7} />
      </clipPath>
    </defs>
  </svg>
);
export default BitcoinFace675;
